export default function (x) {
  return x < 0 ? -1 : 1;
}
